export default __webpack_public_path__ + "static/brand_festo_web-e200b432ba2de13171bf768fd079bee6.png";